import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

export function setupFontAwesome() {
    library.add(faFilePdf);
}